import { useParams } from 'next/navigation';
import type { SupportedGame } from '@/config/supportedGames';

export const useGetGameFromRouteParams = () => {
  // TODO: use string and then validate
  const params = useParams<{ game: string }>();

  return { game: params?.game as SupportedGame };
};
